import {
  Box,
  Center,
  Heading,
  Text,
} from "@chakra-ui/react";
import LineSection from "../lineSection";
import Lang from "../../Lang";

function Texts({ texts }) {
  return (
    <Text
      p={{ base: 4, md: 6, xl: 6 }}
      fontSize={{ base: "1.3em", md: "1.5em", lg: "1.7", xl: "2em" }}
    >
      <Lang text={texts} />
    </Text>
  );
}

export default function General() {
  return (
    <>
      <LineSection />
      <Box
        color='white'
      >
        <Box
          className="opacityTop"
          pt={5}
        >
          <Center>
            <Box maxW={"8xl"}>
              <Heading
                as="h1"
                color={"#fff"}
                align={"center"}
                fontSize={{ base: "4em", md: "5em", lg: "6em", xl: "8em" }}
                py={{ base: 20, md: 40 }}
                className="barlow-black"
              >
                <Lang text="TERMS AND CONDITIONS" />
              </Heading>
            </Box>
          </Center>
        </Box>

        <Center>

          <Box
            w={{ base: "full", md: "3xl", xl: "6xl" }}
            pb={{ base: 20, md: 40 }}
          >
            <Texts texts="AppOX Social Initiatives are an internal program aimed at generating social aid for the most vulnerable communities in society, in order to promote the strengthening of their knowledge and skills in new technologies." />

            <Texts texts="AppOX social initiatives has three programs for bring help to the communities:" />

            <Texts texts="1) AI-Teens: for robotics and programming teams, composed of children up to 17 years old residingt in Colombia, from low-income families and led by a qualified teacher." />

            <Texts texts="2) AI-Prof: for undergraduate bachelor Colombian students enrolled in data science, data engineer, artificial intelligence or similar in an accredited university, with good grades and belonging to a vulnerable population." />

            <Texts texts="3) AI-SmallBusiness: for social enterprises located in Colombia, those with annual revenues less than $200,000 USD, and fewer than 50 employees." />

            <Texts texts="Candidates for AppOX Social help must demonstrate passion and enthusiasm for programming studies and new technologies. AppOX could asks for videos, photos or any other sort of evidence for demonstrate your passion and enthusiasm." />

            <Texts texts="The assistance provided by AppOX may be variable in amount and frequency without prior notice, and there is no defined period of time during which assistance is provided to the beneficiary." />

            <Texts texts="AppOX does not bring money directly to the beneficiaries. All the help is delivered as physical resources such as devices, applications, codes, circuit boards or consumable supplies. For AI-Prof AppOX will contact directly the university for bring help to the beneficiary." />

            <Texts texts="There is no commitment to repay AppOX part or all of the assistance/help provided." />

          </Box>
        </Center>
      </Box >
    </>
  );
}